import { User } from "../type";
import { ActivityReservationInternalModel } from "Services/API/API";

type ActivitiesByDate = Record<string, ActivityReservationInternalModel[]>;

export const getActivitiesByDate = (
   activities: ActivityReservationInternalModel[]
): ActivitiesByDate => {
   const result: ActivitiesByDate = {};

   for (const activity of activities) {
      const { startDate } = activity;

      if (startDate) {
         const [date] = startDate.split("T");
         result[date] ??= [];
         result[date].push(activity)
      }
   }

   return result;
};


interface Chip {
   text: string;
   onClose: () => void;
}

export const parseChipsByUsers = (users: User[], onRemove: (userId: Guid) => void): Chip[] => {
   return users.map(user => ({
      text: user.fullName,
      onClose: () => onRemove(user.id)
   }))
}